import React from "react";
import styles from "./LandingPage.module.css";

const LandingPage = () => {
  return (
    <div className={styles.section}>
      <div className="container-fluid">
        <h1 className={`${styles.heading} mb-5`}>Get in touch with us</h1>
      </div>
    </div>
  );
};

export default LandingPage;
